import moment from 'moment-timezone'

export default (date?: string | string[] | number[], format?: string) =>
  format ? moment(date, format).tz('Asia/Tokyo') : moment.tz(date, 'Asia/Tokyo')
